import {
    Landmark,
    IndianRupee,
    Calendar,
    Briefcase,
    Wallet
} from "lucide-react";

import Card from "../shared/Card";

import { formatCurrency } from "../../utils/formatCurrency";

export default function LoanInfoCard({

    lead

}){

    if(!lead){

        return null;

    }

    return(

        <Card className="crm-loan-card">

            <div className="crm-card-title">

                Loan Information

            </div>

            <div className="crm-info-grid">

                <div className="crm-info-item">

                    <Landmark size={18}/>

                    <div>

                        <label>

                            Loan Type

                        </label>

                        <span>

                            {lead.loan_type || "-"}

                        </span>

                    </div>

                </div>

                <div className="crm-info-item">

                    <IndianRupee size={18}/>

                    <div>

                        <label>

                            Loan Amount

                        </label>

                        <span>

                            {formatCurrency(
                                lead.loan_amount
                            )}

                        </span>

                    </div>

                </div>

                <div className="crm-info-item">

                    <Calendar size={18}/>

                    <div>

                        <label>

                            Tenure

                        </label>

                        <span>

                            {lead.tenure_months
                                ? `${lead.tenure_months} Months`
                                : "-"
                            }

                        </span>

                    </div>

                </div>

                <div className="crm-info-item">

                    <Briefcase size={18}/>

                    <div>

                        <label>

                            Employment

                        </label>

                        <span>

                            {lead.employment_type || "-"}

                        </span>

                    </div>

                </div>

                <div className="crm-info-item">

                    <Wallet size={18}/>

                    <div>

                        <label>

                            Monthly Income

                        </label>

                        <span>

                            {

                                lead.monthly_income

                                ?

                                formatCurrency(
                                    lead.monthly_income
                                )

                                :

                                "-"

                            }

                        </span>

                    </div>

                </div>

            </div>
<style>{`.crm-loan-card{

    display:flex;

    flex-direction:column;

    gap:20px;

}

.crm-card-title{

    font-size:18px;

    font-weight:600;

}

.crm-info-grid{

    display:grid;

    grid-template-columns:repeat(2,1fr);

    gap:18px;

}

.crm-info-item{

    display:flex;

    gap:12px;

    align-items:flex-start;

}

.crm-info-item label{

    display:block;

    font-size:12px;

    color:#888;

    margin-bottom:4px;

}

.crm-info-item span{

    font-size:15px;

    font-weight:500;

}

@media(max-width:600px){

.crm-info-grid{

    grid-template-columns:1fr;

}

}`}</style>
        </Card>

    );

}